import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconArrowLeft(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M11.707 18.707a1 1 0 0 1-1.414 0l-6-6a1 1 0 0 1 0-1.414l6-6a1 1 0 1 1 1.414 1.414L7.414 11H19a1 1 0 1 1 0 2H7.414l4.293 4.293a1 1 0 0 1 0 1.414Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
